// src/pages/admin/AdminLanding.jsx
import { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { API_BASE_URL } from '../../utils/constants';
import AdminLogin from '../../pages/admin/AdminLogin';

const AdminLanding = () => {
  const [status, setStatus] = useState('checking');
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (location.pathname !== '/admin') return;

    const authFlag = localStorage.getItem('adminAuth');
    const expiresAtStr = localStorage.getItem('adminExpiresAt');

    if (authFlag !== 'true' || !expiresAtStr) {
      setStatus('not-auth');
      return;
    }

    const checkSession = async () => {
      try {
        const res = await fetch(`${API_BASE_URL}/api/admin/me`, {
          method: 'GET',
          credentials: 'include', // send admin_jwt cookie
          headers: { 'Content-Type': 'application/json' },
        });

        if (res.ok) {
          // Logged in → go straight to dashboard
          navigate('/admin/dashboard', { replace: true });
        } else {
          // Not logged in / expired
          localStorage.removeItem('adminAuth');
          localStorage.removeItem('adminToken');
          localStorage.removeItem('adminExpiresAt');
          setStatus('not-auth');
        }
      } catch (e) {
        console.error('Error checking admin session:', e);
        setStatus('not-auth');
      }
    };

    checkSession();
  }, [navigate]);

  if (status === 'checking') {
    return (
      <div className="p-6 text-center text-sm text-gray-500">
        Proveravam administratorsku sesiju...
      </div>
    );
  }

  // Not authenticated → show login ON /admin
  return <AdminLogin />;
};

export default AdminLanding;
